import { render, staticRenderFns } from "./DistributorTableManagers.vue?vue&type=template&id=2fab1777"
import script from "./DistributorTableManagers.vue?vue&type=script&lang=js"
export * from "./DistributorTableManagers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports